// import { useMemo } from 'react'
import { BigNumber } from '@ethersproject/bignumber'
import { AddressZero } from '@ethersproject/constants'
import { utils } from 'ethers'
// import dateFormat from 'dateformat'
import { useLockFactoryContract } from '../hooks/useContract'
import { useSingleCallResult } from '../state/multicall/hooks'

export function useMemeList(owner: string): any {
  
  const contract = useLockFactoryContract(false)
  const tokenList = useSingleCallResult(contract, 'getUserMemeList', [owner]).result

   if (!owner || owner === AddressZero) {
    return {
      tokenList: []
    }
  }
 
  const tokens = tokenList?.list || []
  const tokensView = tokens.map((item:any) => {
    return {
      amount: BigNumber.from(item.initialAmount.toString()).div(`${10 ** 18}`).toString(),
      symbol: item.symbol,
      tokenAddress: item.memeAddress,
      lockAdderss: item.lockAdderss,
    }
  })
   const tokenTrueList = tokensView.filter((item) => {
      return item.tokenAddress !== AddressZero
    })
  return {
    tokenList: tokenTrueList
  }
}

export default useMemeList
